import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Circle } from 'rc-progress';
import { TweenMax } from 'gsap';

import createFadeInAnimation from '../../animations/fadeIn';
import createFadeOutAnimation from '../../animations/fadeOut';

const propTypes = {
    percent: PropTypes.number,
    turnOnSound: PropTypes.string.isRequired,
    visible: PropTypes.bool,
    loadingDuration: PropTypes.number,
    lastProgress: PropTypes.number,
    onComplete: PropTypes.func,
    onLastProgress: PropTypes.func,
};

const defaultProps = {
    percent: 0,
    visible: false,
    loadingDuration: 5,
    lastProgress: 0.5,
    onComplete: null,
    onLastProgress: null,
};

class Loading extends Component {
    constructor(props) {
        super(props);

        this.timelineFadeIn = null;
        this.timelineFadeOut = null;
        this.percentTween = null;

        this.refContainer = null;

        this.state = {
            percent: props.percent * 0.5,
        };
    }

    componentDidMount() {
        this.timelineFadeIn = createFadeInAnimation(this.refContainer).paused(true);
        this.timelineFadeOut = createFadeOutAnimation(this.refContainer).paused(true);
    }

    componentDidUpdate(prevProps) {
        const { lastProgress } = this.props;
        // Check loading
        const percentChanged = prevProps.percent !== this.props.percent;
        const visibleChanged = prevProps.visible !== this.props.visible;
        if ((percentChanged || visibleChanged) && this.props.visible) {
            const realProgress = 1 - lastProgress;
            this.updatePercent((this.props.percent * realProgress) + (lastProgress * 100));
        }
    }

    getTimelineFadeIn() {
        return this.timelineFadeIn;
    }

    getTimelineFadeOut() {
        return this.timelineFadeOut;
    }

    updatePercent(nextPercent) {
        const { loadingDuration, lastProgress, onComplete, onLastProgress } = this.props;
        const percentObj = {
            percent: this.state.percent,
        };
        if (this.percentTween !== null) {
            this.percentTween.kill();
        }
        const durationPercent = Math.abs(nextPercent - this.state.percent) / 100;
        const duration = durationPercent * loadingDuration;
        this.percentTween = TweenMax.to(percentObj, duration, {
            percent: nextPercent,
            onUpdate: () => {
                const lastPercent = (lastProgress * 100);
                if (percentObj.percent > lastPercent && onLastProgress) {
                    onLastProgress((percentObj.percent - lastPercent) / (100 - lastPercent));
                }
                this.setState(() => ({
                    percent: percentObj.percent,
                }));
            },
            onComplete: () => {
                if (percentObj.percent >= 100 && onComplete) {
                    onComplete();
                }
            },
        });
    }

    render() {
        const {
            turnOnSound,
        } = this.props;
        const { percent } = this.state;
        return (
            <div
                className="slide slide-loading fullscreen"
                ref={(ref) => { this.refContainer = ref; }}
            >
                <div className="table fullscreen">
                    <div className="cell middle">
                        <div className="loading">
                            <div className="table fullscreen">
                                <div className="cell middle">
                                    <div className="label">
                                        <ReactMarkdown
                                            source={turnOnSound}
                                        />
                                    </div>
                                </div>
                            </div>
                            <Circle
                                percent={percent * 0.99}
                                strokeWidth="3"
                                strokeColor="#FFFFFF"
                                trailWidth="3"
                                trailColor="rgba(255, 255, 255, 0.2)"
                                strokeLinecap="square"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Loading.propTypes = propTypes;
Loading.defaultProps = defaultProps;

export default Loading;



// WEBPACK FOOTER //
// ./components/partials/Loading.jsx